import * as t from 'constants/ActionTypes.js';
import { createAction } from 'redux-actions';
import axios from 'axios';
import { ROOT_URL } from 'constants/Config.js';

export const showNotification = createAction(t.SHOW_PAYMENT_NOTIFCATION, () => {
  localStorage.setItem('psd', Date.now());
});

export const hideNotification = createAction(t.HIDE_PAYMENT_NOTIFCATION);

export const requestToConnect = createAction(t.REQUEST_TO_CONNECT, async (data) => {
  await axios.post(`${ROOT_URL}/user/company/send/email`, data);
});

// export const requestToConnect = (вфеф) => (dispatch, getState) =>
//   dispatch(_requestToConnect(getState));



// WEBPACK FOOTER //
// ./src/actions/payments.js